/*
 * Coleção: filtros e ordenação sem recarregar (Section Rendering API),
 * drawer de filtros no mobile e integração com o histórico do navegador.
 * Sem JS, o <form> de filtros continua funcionando por GET normal.
 */
(function () {
  var DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

  var state = {
    controller: null,
    currentUrl: window.location.href,
    changedWhileOpen: false,
    lastTrigger: null,
    live: null
  };

  /* ---------- Helpers ---------- */
  function getRoot() { return document.querySelector('[data-collection-root]'); }
  function getFilters() { var r = getRoot(); return r ? r.querySelector('[data-filters]') : null; }
  function isDrawerOpen() { var f = getFilters(); return !!(f && f.classList.contains('is-open')); }
  function absoluteUrl(url) { return new URL(url, window.location.href).href; }

  function announce(message) {
    if (!state.live) {
      state.live = document.createElement('div');
      state.live.className = 'visually-hidden';
      state.live.setAttribute('aria-live', 'polite');
      state.live.setAttribute('role', 'status');
      document.body.appendChild(state.live);
    }
    state.live.textContent = '';
    window.setTimeout(function () { state.live.textContent = message; }, 60);
  }

  function formToUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    var query = params.toString();
    return absoluteUrl(form.getAttribute('action') + (query ? '?' + query : ''));
  }

  function setDialogSemantics(filters, open) {
    var panel = filters && filters.querySelector('[data-filters-panel]');
    if (!panel) return;
    if (open) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
    }
  }

  function setToggleExpanded(expanded) {
    document.querySelectorAll('[data-filters-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* ---------- Drawer (mobile) ---------- */
  function openDrawer(trigger) {
    var filters = getFilters();
    if (!filters || DESKTOP_QUERY.matches) return;
    state.lastTrigger = trigger || null;
    state.changedWhileOpen = false;
    filters.classList.add('is-open');
    setDialogSemantics(filters, true);
    setToggleExpanded(true);
    document.body.style.overflow = 'hidden';
    // Entrada extra no histórico: o botão "voltar" do celular fecha o drawer.
    history.pushState({ mFiltersDrawer: true }, '', window.location.href);
    var closeBtn = filters.querySelector('[data-filters-close-btn]');
    if (closeBtn) window.setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer(fromPopstate) {
    var filters = getFilters();
    if (!filters || !filters.classList.contains('is-open')) return;
    filters.classList.remove('is-open');
    setDialogSemantics(filters, false);
    setToggleExpanded(false);
    document.body.style.overflow = '';

    if (!fromPopstate && history.state && history.state.mFiltersDrawer) {
      if (state.changedWhileOpen) {
        history.replaceState({ mCollection: true }, '', window.location.href);
      } else {
        history.back(); // remove a entrada extra criada ao abrir
      }
    }

    var trigger = state.lastTrigger && document.body.contains(state.lastTrigger)
      ? state.lastTrigger
      : document.querySelector('[data-filters-open]');
    if (trigger) trigger.focus({ preventScroll: true });
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !isDrawerOpen()) return;
    var panel = getFilters().querySelector('[data-filters-panel]');
    var focusables = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* ---------- Renderização via Section Rendering API ---------- */
  function render(url, historyMode) {
    var root = getRoot();
    if (!root || !window.fetch || !window.DOMParser) { window.location.href = url; return; }

    url = absoluteUrl(url);
    var sectionId = root.getAttribute('data-section-id');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    if (state.controller) state.controller.abort();
    var controller = 'AbortController' in window ? new AbortController() : null;
    state.controller = controller;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    fetch(fetchUrl, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-collection-root]');
        if (!next) throw new Error('Seção não encontrada na resposta');

        var current = getRoot();
        var currentFilters = current.querySelector('[data-filters]');
        var wasOpen = !!(currentFilters && currentFilters.classList.contains('is-open'));
        var active = document.activeElement;
        var focusedId = active && current.contains(active) ? active.id : null;
        var body = current.querySelector('[data-filters-body]');
        var bodyScroll = body ? body.scrollTop : 0;

        // Preserva quais grupos do acordeão estavam abertos/fechados
        current.querySelectorAll('[data-filter-group]').forEach(function (group) {
          var key = group.getAttribute('data-filter-group');
          next.querySelectorAll('[data-filter-group]').forEach(function (candidate) {
            if (candidate.getAttribute('data-filter-group') === key) candidate.open = group.open;
          });
        });

        var nextFilters = next.querySelector('[data-filters]');
        if (wasOpen && nextFilters) {
          nextFilters.classList.add('is-open', 'is-instant');
          setDialogSemantics(nextFilters, true);
        }

        current.replaceWith(next);

        var nextBody = next.querySelector('[data-filters-body]');
        if (nextBody) nextBody.scrollTop = bodyScroll;
        if (nextFilters) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { nextFilters.classList.remove('is-instant'); });
          });
        }
        setToggleExpanded(wasOpen);

        if (focusedId) {
          var toFocus = document.getElementById(focusedId);
          if (toFocus) toFocus.focus({ preventScroll: true });
        }

        state.currentUrl = url;
        if (historyMode === 'push') history.pushState({ mCollection: true }, '', url);
        else if (historyMode === 'replace') history.replaceState(history.state, '', url);
        if (wasOpen) state.changedWhileOpen = true;

        var count = next.querySelector('.m-collection__count');
        if (count) announce(count.textContent.trim());
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = url; // fallback: navegação normal
      });
  }

  function apply(url) {
    render(url, isDrawerOpen() ? 'replace' : 'push');
  }

  /* ---------- Eventos (delegação: sobrevive à troca do HTML) ---------- */
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-filters-open]');
    if (openBtn) { event.preventDefault(); openDrawer(openBtn); return; }

    var closeBtn = event.target.closest('[data-filters-close]');
    if (closeBtn) { event.preventDefault(); closeDrawer(false); return; }

    var link = event.target.closest('a[data-filter-link]');
    if (link && getRoot() && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      apply(link.href);
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    var form = target.form;
    if (!form || !form.matches('[data-filters-form]')) return;
    if (target.type === 'checkbox' || target.matches('[data-sort-select]')) {
      apply(formToUrl(form));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-filters-form]')) return;
    event.preventDefault();
    apply(formToUrl(form));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isDrawerOpen()) { closeDrawer(false); return; }
    trapFocus(event);
  });

  window.addEventListener('popstate', function (event) {
    if (isDrawerOpen() && !(event.state && event.state.mFiltersDrawer)) closeDrawer(true);
    if (getRoot() && window.location.href !== state.currentUrl) render(window.location.href, 'none');
  });

  // Se a tela crescer para desktop com o drawer aberto, fecha e destrava o scroll.
  var onBreakpoint = function (event) { if (event.matches && isDrawerOpen()) closeDrawer(false); };
  if (DESKTOP_QUERY.addEventListener) DESKTOP_QUERY.addEventListener('change', onBreakpoint);
  else if (DESKTOP_QUERY.addListener) DESKTOP_QUERY.addListener(onBreakpoint);
})();
